var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar',{class:{ 'hide-navbar': _vm.$route.name === 'internal' || _vm.$route.name === 'internal login'}}),_c('v-main',[_c('router-view'),_c('AppFooter',{class:{ 'hide-navbar': _vm.$route.name === 'internal' || _vm.$route.name === 'internal login' }})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }